// Кадрированная версия фото (после «Изменить» — обрезка/выравнивание) — как в
// приле: карточки (поиск, пины, просмотры, превью профиля) берут
// photoCropNormal, если он настоящий, иначе исходник.
const isReal = (u?: string | null) => !!u && u.indexOf("empty_main_photo") < 0;

export const pickCropped = (crop?: string | null, original?: string | null): string =>
  (isReal(crop) ? (crop as string) : (original || "")) as string;

export const mainPhotoCropNormal = (mp: any): string =>
  pickCropped(mp?.photoCropNormal, mp?.photoNormal);

export const mainPhotoCropSmall = (mp: any): string =>
  pickCropped(mp?.photoCropSmall, mp?.photoSmall);
